export default (state, action) => {
  const estimate = state[action.payload.designId];

  return {
    ...state,
    [action.payload.designId]: {
      ...estimate,
      isLinked: true,
      sharedEmail: null,
    },
  };
};
